import proj4 from 'proj4';

export const formatEPSG4326 = (x, y) => {
    proj4.defs["EPSG:5179"] = "+proj=tmerc +lat_0=38 +lon_0=127.5 +k=0.9996 +x_0=1000000 +y_0=2000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs";//제공되는 좌표
    const grs80 = proj4.Proj(proj4.defs["EPSG:5179"])
    const wgs84 = proj4.Proj(proj4.defs["EPSG:4326"]); //경위도
    const p = proj4.toPoint( [Number(x) , Number(y)] );
    const pt = proj4.transform( grs80, wgs84, p)
    return pt;
};



